import React from "react";
import SlaveryTable from "./SlaveryTable/SlaveryTable";

export default function SlaveryCard(props) {
    const { slavery_data } = props
    const hasSource = Object.keys(slavery_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                Trabalho Escravo - Match encontrado
            </p>
            <SlaveryTable slavery_data={slavery_data.source} />
        </div>
    )
}
